import React from "react";
import { Reveal, Overline, GlowOrb, GridBackdrop } from "@/components/primitives";

export default function PageHero({ overline, title, sub, children }) {
  return (
    <section className="relative pt-40 pb-20 overflow-hidden">
      <GridBackdrop />
      <GlowOrb className="h-[420px] w-[420px] -top-20 -left-20" />
      <GlowOrb className="h-[360px] w-[360px] top-10 right-0" color="rgba(26,232,189,0.10)" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        {overline && (
          <Reveal>
            <Overline>{overline}</Overline>
          </Reveal>
        )}
        <Reveal delay={0.06}>
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-heading font-bold tracking-tighter leading-[1.03] text-white max-w-4xl">
            {title}
          </h1>
        </Reveal>
        {sub && (
          <Reveal delay={0.12}>
            <p className="mt-6 text-base md:text-lg text-slate-300 leading-relaxed max-w-2xl">
              {sub}
            </p>
          </Reveal>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
